import React from 'react';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { QSpinner } from '@kubiq-base/core';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../state/ApiContext';
import { useCache } from '../../state/CachingContext';
import PageError from '../Shared/PageError';

const RequestPasswordReset = (): JSX.Element => {
  const { postRequest } = useApi();
  const { getCache } = useCache();

  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const navigate = useNavigate();

  const email = getCache('email');

  const bootstrapAsync = async (): Promise<void> => {
    if (email) {
      await postRequest('ResetPassword/RequestReset', { email: email }, setIsSubmitting)
        .then(() => navigate('/Recovery/CheckEmail'))
        .catch(() => setShowErrorMessage(true));
    } else {
      setShowErrorMessage(true);
    }
  };

  React.useEffect(() => {
    bootstrapAsync();
  }, []);

  return (
    <>
      {showErrorMessage ? (
        <PageError message='wentWrong' translationNamespace={TranslationNamespaces.global} />
      ) : (
        isSubmitting && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 72 }}>
            <QSpinner />
          </div>
        )
      )}
    </>
  );
};

export default RequestPasswordReset;
